/*
 * Dave Tech: keeps --dt-tools-h equal to the carrier strip's real height (it grows on Fridays), so collapsing
 * the strip on scroll (dt-mobile-header.css) never makes the page jump.
 */
(() => {
  const tools = document.querySelector(".dt-header-tools");
  const section = tools && tools.closest(".shopify-section-header-sticky");
  if (!tools || !section) return;
  const update = () => {
    if (section.classList.contains("scrolled-past-header")) return; // hidden: keep the last real height
    const h = tools.getBoundingClientRect().height;
    if (h > 0) section.style.setProperty("--dt-tools-h", `${Math.round(h)}px`);
  };
  update();
  if ("ResizeObserver" in window) new ResizeObserver(update).observe(tools);
  window.addEventListener("resize", update, { passive: true });
})();
